<div class="country-select w-full">
  <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400">
    {{ label }}
    @if (required) {
    <span class="text-error-500">*</span>
    }
  </label>

  <div class="relative" cdkOverlayOrigin #origin="cdkOverlayOrigin">
    <button type="button"
      class="flex h-11 w-full items-center gap-3 rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-left text-sm text-gray-800 shadow-theme-xs transition-colors dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
      [class.opacity-60]="disabled()" [class.cursor-not-allowed]="disabled()"
      (click)="toggleDropdown()"
      (keydown)="onButtonKeyDown($event)"
      [attr.aria-expanded]="dropdownOpen()"
      [attr.aria-haspopup]="'listbox'"
      role="combobox">
      @if (selectedCountry(); as country) {
      <div class="flex items-center gap-3 truncate text-left">
        <img [src]="'assets/flags/' + country.isoCode.toLowerCase() + '.svg'" [alt]="country.name" class="size-6 rounded-full object-cover" />
        <div class="flex flex-col leading-tight">
          <span class="text-sm font-medium text-gray-800 dark:text-white/90">{{ country.name }}</span>
          <span class="text-xs text-gray-500 dark:text-gray-400">{{ country.dialCode }} • {{ country.isoCode }}</span>
        </div>
      </div>
      } @else {
      <span class="text-sm text-gray-400 dark:text-gray-500">{{ placeholder }}</span>
      }
      <span class="ml-auto text-gray-500 dark:text-gray-400">
        <svg class="stroke-current transition-transform duration-200"
          [style.transform]="dropdownOpen() ? 'rotate(180deg)' : 'rotate(0deg)'" width="20" height="20"
          viewBox="0 0 20 20" fill="none">
          <path d="M4.79175 7.396L10.0001 12.6043L15.2084 7.396" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </span>
    </button>

    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="origin"
      [cdkConnectedOverlayOpen]="dropdownOpen()" [cdkConnectedOverlayPositions]="overlayPositions"
      [cdkConnectedOverlayWidth]="overlayWidth()" cdkConnectedOverlayPanelClass="country-select-overlay-panel"
      (overlayOutsideClick)="dropdownOpen.set(false)"
      (detach)="dropdownOpen.set(false)">
      <div
        class="mt-2 w-full rounded-xl border border-gray-200 bg-white shadow-xl dark:border-gray-700 dark:bg-gray-900">
      <div class="p-2">
        <div class="relative">
          <input #searchInput type="text"
            class="h-10 w-full rounded-lg border border-gray-300 bg-gray-50 px-3 pr-9 text-sm text-gray-700 focus:border-brand-300 focus:outline-hidden focus:ring-2 focus:ring-brand-500/20 dark:border-gray-700 dark:bg-gray-800 dark:text-white/90"
            [placeholder]="searchPlaceholder"
            (input)="onSearch($event)"
            (keydown)="onSearchKeyDown($event)"
            [value]="searchTerm()">
          <span class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
            <svg class="stroke-current" width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path
                d="M21 21L15.8 15.8M15.8 15.8C15.8 15.8 17 14 17 11C17 7.13401 13.866 4 10 4C6.13401 4 3 7.13401 3 11C3 14.866 6.13401 18 10 18C13 18 15.8 15.8 15.8 15.8Z"
                stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
        </div>
      </div>
      <div #countryList class="max-h-64 overflow-y-auto p-1" role="listbox">
        @for (country of filteredCountries(); track country.countryId; let i = $index) {
        <button type="button"
          class="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
          [class.bg-brand-50]="highlightedIndex() === i"
          [class.dark:bg-brand-500/10]="highlightedIndex() === i"
          [attr.aria-selected]="highlightedIndex() === i"
          role="option"
          (click)="selectCountry(country)"
          (keydown)="onCountryItemKeyDown($event, country, i)"
          (mouseenter)="highlightedIndex.set(i)">
          <img [src]="'assets/flags/' + country.isoCode.toLowerCase() + '.svg'" [alt]="country.name" class="size-5 rounded-full object-cover" />
          <div class="flex flex-col text-left">
            <span class="text-sm font-medium text-gray-800 dark:text-white/90">{{ country.name }}</span>
            <span class="text-xs text-gray-500 dark:text-gray-400">{{ country.dialCode }} • {{ country.isoCode }}</span>
          </div>
        </button>
        } @empty {
        <p class="px-3 py-2 text-sm text-gray-500 dark:text-gray-400">No encontramos coincidencias.</p>
        }
      </div>
      </div>
    </ng-template>
  </div>
</div>
